export default __webpack_public_path__ + "static/media/info-icon.d3cfc205.svg";